"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _CoreProps = require("../utilities/CoreProps");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FavoriteStar = _ref => {
  let {
    className,
    favorited
  } = _ref;
  const classNames = (0, _classnames.default)({
    'is-favorited': favorited
  });
  return /*#__PURE__*/_react.default.createElement("i", {
    className: (0, _classnames.default)('material-icons', 'favorite-star', className, classNames) || undefined
  }, "star");
};
FavoriteStar.propTypes = {
  favorited: _propTypes.default.bool,
  className: _propTypes.default.string
};
FavoriteStar.defaultProps = {
  favorited: false,
  className: ''
};
var _default = exports.default = (0, _CoreProps.withUiProps)(FavoriteStar);
//# sourceMappingURL=FavoriteStar.js.map